import DOMPurify from 'dompurify';

export const getCWPEnvironmentForURL = (function () {
  const environments = [
    {
      name: 'localhost:6006',
      pattern: /^(http|https):?\/\/localhost:6006/,
    },
    {
      name: 'localhost:8080',
      pattern: /^(http|https):?\/\/localhost:8080\/site\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8081',
      pattern: /^(http|https):?\/\/localhost:8081\/site\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:9100',
      pattern: /^(http|https):?\/\/localhost:9100/,
    },
    {
      name: 'localhostcms',
      pattern:
        /^(http|https):?\/\/localhost:(8080|8081)\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8080cms',
      pattern:
        /^(http|https):?\/\/localhost:8080\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8081cms',
      pattern:
        /^(http|https):?\/\/localhost:8081\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhostpreview',
      pattern:
        /^(http|https):?\/\/localhost:(8080|8081)\/site\/(ampmicrosites|joinameriprise)\/preview/,
    },
    {
      name: 'devcms',
      pattern: /^(http|https):?\/\/cms-ws\d*\.dev\.ameriprise.com/,
    },
    {
      name: 'dev',
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'devpreview',
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'qawscms',
      pattern: /^(http|https):?\/\/cms-ws\d*\.qa\.ameriprise.com/,
    },
    {
      name: 'qaws',
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'qawspreview',
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'qacms',
      pattern: /^(http|https):?\/\/cms\.qa\.ameriprise.com/,
    },
    {
      name: 'qa',
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'qapreview',
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'prodcms',
      pattern: /^(http|https):?\/\/cms\.ameriprise.com/,
    },
    {
      name: 'prod',
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'prodpreview',
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)\/preview/,
    },
  ];

  return function getCWPEnvironmentForURL(url) {
    url = url || window.location.toString();

    let result;

    environments.forEach(function (environment) {
      if (environment.pattern.test(url)) result = environment.name;
    });

    result = result ?? 'prod';
    return result;
  };
})();

export const APIENDPOINT = env => {
  let base = '';
  let baseGallery = '';
  let menuBase = '';
  let menuBaseWithParams = '';
  let advisor = '';
  switch (env) {
    case 'localhost:8080':
      base = 'http://localhost:8080/site/ampmicrosites/';
      baseGallery = '/site/binaries/';
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/';
      menuBaseWithParams = 'http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/';
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/';
      break;
    case 'localhost:8080cms':
      base = 'http://localhost:8080/site/_cmsinternal/ampmicrosites/';
      baseGallery = '/site/binaries/';
      menuBase = 'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus/local-ampmicrosites/';
      menuBaseWithParams =
        'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus-ext/local-ampmicrosites/';
      break;
    case 'localhost:8081cms':
      base = 'http://localhost:8081/site/_cmsinternal/ampmicrosites/';
      baseGallery = '/site/binaries/';
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/';
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/';
      break;
    case 'localhostpreview':
      base = 'http://localhost:8080/site/ampmicrosites/preview/';
      baseGallery = '/site/binaries/';
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/preview/';
      menuBaseWithParams =
        'http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/preview/';
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/';
      break;
    case 'localhost:8081':
      base = 'http://localhost:8081/site/ampmicrosites/';
      baseGallery = '/site/binaries/';
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/';
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/';
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/';
      break;
    case 'localhost:6006':
      base = '/microsite/';
      baseGallery = '/binaries/';
      menuBase = '/cfgapi/hst/menus/ampmicrosites/';
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/';
      break;
    case 'localhost:9100':
      base = 'https://www.qa.ameriprise.com/microsite/';
      baseGallery = 'https://www.qa.ameriprise.com/microsite/binaries/';
      menuBase = 'https://www.qa.ameriprise.com/cfgapi/hst/menus/ampmicrosites/';
      menuBaseWithParams = 'https://www.qa.ameriprise.com/cfgapi/hst/menus-ext/ampmicrosites/';
      break;
    case 'devcms':
    case 'qawscms':
    case 'qacms':
    case 'prodcms':
      base = '/site/_cmsinternal/microsite/';
      baseGallery = '/site/_cmsinternal/binaries/';
      menuBase = '/site/_cmsinternal/cfgapi/hst/menus/ampmicrosites/';
      menuBaseWithParams = '/site/_cmsinternal/cfgapi/hst/menus-ext/ampmicrosites/';
      break;
    case 'dev':
      base = '/microsite/';
      baseGallery = '/binaries/';
      menuBase = '/cfgapi/hst/menus/ampmicrosites/';
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/';
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/';
      break;
    case 'qaws':
    case 'qa':
    case 'prod':
      base = '/microsite/';
      baseGallery = '/binaries/';
      menuBase = '/cfgapi/hst/menus/ampmicrosites/';
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/';
      advisor = '/api/advisorsv22/json/';
      break;
    case 'devpreview':
    case 'qawspreview':
    case 'qapreview':
      base = '/microsite/preview/';
      baseGallery = '/binaries/';
      menuBase = '/cfgapi/hst/menus/ampmicrosites-preview/';
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites-preview/';
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/';
      break;
  }
  return { base, baseGallery, menuBase, menuBaseWithParams, advisor };
};

export const CONSTs = {
  PRODUCTION: 'production',
  QA: 'qa',
  DEV: 'dev',
  LOCAL: 'local',
  PREVIEW: 'preview',
  UNKNOWN: 'unknown',
  POPOVER_CLASS: 'Popover',
  IS_VISIBLE_CLASS: 'is-visible',
};

export function getEnvironment() {
  const isLocal =
    /localhost|127\.0\.0\.1/i.test(window.location.toString()) || window.location.port === '8081';
  const isAmeriprisePublicSite =
    /(www|www1)(-ws1|preview|demo)?(\.qa.stage|\.qa|.dev)?\.ameriprise\.com/.test(
      window.location.toString()
    );
  const isAnyLower =
    /dev|ws1.dev|qa|ws1.qa|qa.stage|preview|127\.0\.0\.1|local/i.test(window.location.toString()) ||
    window.location.port === '8081';
  const isAmpLower = isAmeriprisePublicSite && isAnyLower;
  const isProd = !isAnyLower && !isAmpLower;
  const isDev = /dev|ws1.dev\./i.test(window.location.toString());
  const isQa = /qa|ws1.qa\./i.test(window.location.toString());
  const isPreview = /preview\./i.test(window.location.toString());

  switch (true) {
    case isProd:
      return CONSTs.PRODUCTION;
    case isLocal:
      return CONSTs.LOCAL;
    case isQa:
      return CONSTs.QA;
    case isDev:
      return CONSTs.DEV;
    case isPreview:
      return CONSTs.PREVIEW;
    default:
      return CONSTs.UNKNOWN;
  }
}

export const getNavItems = (halItems, showOptOut) => {
  const navItems = halItems || [];
  if (showOptOut) {
    return navItems;
  }
  return filterOptOut(navItems);
};

export const filterOptOut = navItems => {
  return navItems.filter(currMenu => {
    // in next release I will change how this is done to use resource bundle
    return currMenu.text !== 'Do Not Sell or Share My Personal Data';
  });
};

export function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerText = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
  return txt.innerText;
}

export function decodeEntities(encodedString) {
  const translateRe = /&(nbsp|amp|quot|lt|gt);/g;
  const translate = {
    nbsp: ' ',
    amp: '&',
    quot: "'",
    lt: '<',
    gt: '>',
  };
  return encodedString
    .replace(translateRe, function (match, entity) {
      return translate[entity];
    })
    .replace(/&#(\d+);/gi, function (match, numStr) {
      const num = parseInt(numStr, 10);
      return String.fromCharCode(num);
    });
}

export function sanitizeHTML(data) {
  return DOMPurify.sanitize(decodeEntities(decodeHtml(data)), { ADD_ATTR: ['target'] });
}

/**
 * @param {String} query
 *
 * parseQuery('foo&bar=baz&greeting=Hello%2C%20World!')
 * // { foo: true, bar: 'baz', greeting: 'Hello, World!' }
 */
export function parseQuery(query = '') {
  const result = {};
  if (!query.length) return result;
  query
    .replace(/^\?/, '')
    .split('&')
    .forEach(item => {
      const parts = item.split('=');
      const key = parts[0];
      const value = parts[1];

      result[key] = value ? decodeURIComponent(value) : true;
    });

  return result;
}

/**
 * changes &amp; to just & for links and other strings
 * @param {String} link
 * @returns {String}
 */
export function cleanLink(link) {
  return link.replace(/&amp;/g, '&');
}

/**
 *
 */
export function sanitizeImgSrc(url) {
  try {
    // Allow only https URLs or relative paths
    if (url.startsWith('/') || url.startsWith('https://')) {
      return url;
    }
  } catch {}
  return '';
}

//Working environment URLs. This list can be edited as needed, and should be kept up to date.
const ALLOWED_HOSTNAMES = [
  'www.ameriprise.com',
  'www.ameripriseadvisors.com',
  'www.qa.ameriprise.com',
  'www-ws1.qa.ameriprise.com',
  'www-ws2.qa.ameriprise.com',
  'www-ws3.qa.ameriprise.com',
  'www-ws4.qa.ameriprise.com',
  'www-ws5.qa.ameriprise.com',
  'perf.qa.ameriprise.com',
  'secure.ameriprise.com',
  'secure-01.qa.ameriprise.com',
];

export function isValidUrl(url) {
  try {
    const emptyUrl = '';
    const parsedUrl = new URL(
      url,
      url.includes('https') || url.includes('http') ? undefined : window.location.origin
    );
    const allowedSchemes = ['http:', 'https:'];
    const hostname = parsedUrl.hostname;

    if (!allowedSchemes.includes(parsedUrl.protocol)) return emptyUrl;

    const isLocalhost = hostname === 'localhost';
    const isLoopbackIPv4 = /^127\.\d+\.\d+\.\d+$/.test(hostname);
    const isPrivateIPv4 = /^(10\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[0-1])\.)/.test(hostname);
    const isLinkLocalIPv4 = /^169\.254\./.test(hostname);
    const isLoopbackIPv6 = hostname === '::1';

    if (isLocalhost || isLoopbackIPv4 || isPrivateIPv4 || isLinkLocalIPv4 || isLoopbackIPv6) {
      return emptyUrl;
    }

    // Only allow URLs with hostnames in ALLOWED_HOSTNAMES for SSRF mitigation
    if (!ALLOWED_HOSTNAMES.includes(hostname)) {
      return emptyUrl;
    }

    return url;
  } catch (error) {
    console.warn(error);
    return '';
  }
}

export function validEmail(email) {
  const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const safeEmail = isValidEmail(email) ? email : '';

  return safeEmail;
}

export function validPhone(phone) {
  return phone.replaceAll(/[^\d.\-\s()]/g, '');
}
